import { useEffect, useState } from "react";
import { TEAM } from "../lib/data";
import { api, imgSrc } from "../lib/api";
import { PageHero } from "../components/PageHero";
import { FadeUp } from "../components/Reveal";
import { CtaSection } from "../components/CtaSection";

const TeamCard = ({ member, index }) => (
  <FadeUp delay={0.08 * (index % 3)}>
    <article
      data-testid={`team-card-${member.id}`}
      className="group border border-white/10 bg-[#0d0d0d] transition-colors duration-500 hover:border-gold/40"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        {member.foto ? (
          <img
            src={imgSrc(member.foto)}
            alt={member.nama}
            className="h-full w-full object-cover grayscale transition-all duration-700 group-hover:scale-[1.04] group-hover:grayscale-0"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-[#101010]">
            <span
              className="font-serif text-8xl italic text-gold/25 transition-colors duration-700 group-hover:text-gold/45"
              aria-hidden="true"
            >
              {member.inisial}
            </span>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 p-6">
          <h3 className="font-serif text-2xl leading-tight text-white">
            {member.nama}
          </h3>
          <p className="mt-2 text-[11px] font-medium uppercase tracking-[0.3em] text-gold">
            {member.peran}
          </p>
        </div>
      </div>
      <p className="p-6 text-sm font-light leading-relaxed text-[#A3A3A3]">
        {member.bio}
      </p>
    </article>
  </FadeUp>
);

export default function Tim() {
  const [team, setTeam] = useState(TEAM);

  useEffect(() => {
    api
      .get("/team")
      .then((r) => { if (r.data.length) setTeam(r.data); })
      .catch(() => {});
  }, []);

  return (
    <>
      <PageHero
        eyebrow="Tim Kami"
        titleLines={[
          "Para pembela di",
          <span key="t" className="italic text-gold">
            garda terdepan.
          </span>,
        ]}
        description="Tim YLBH Sumatera Timur terdiri dari para profesional hukum berpengalaman yang sangat berdedikasi untuk memberikan layanan terbaik bagi klien. Dengan keahlian lintas sektor dan komitmen terhadap integritas, kami hadir untuk menemani Anda setiap langkah dengan cara yang dapat dipercaya dan berorientasi solusi."
      />
      <section className="mx-auto w-full max-w-7xl px-6 pb-28 lg:px-10">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {team.map((m, i) => (
            <TeamCard key={m.id} member={m} index={i} />
          ))}
        </div>
      </section>
      <CtaSection
        testid="tim-cta"
        lines={[
          "Butuh pendamping yang tepat?",
          <span key="t" className="italic text-gold">
            Kami siap mendengar.
          </span>,
        ]}
      />
    </>
  );
}
